import styled from 'styled-components';

export const Modal = styled.div`
  z-index: 99;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(0, 0, 0, 0.6);
  width: 100%;
  height: 100%;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: transparent;

  width: max-content;
  height: max-content;
  max-width: 100%;
  max-height: 80%;
  padding: 0.2rem;
  overflow-y: auto;

  background: #fff;

  .activityTrackerBtnc {
    > button {
      display: flex;
      flex-direction: row;
      background: #8e44ad;
      color: #fff;
      border-radius: 8px;
      font-size: 14px;
      margin-right: 5px;
      gap: 0.2rem;
      padding: 0.5rem 1rem;
      font-weight: 600;
      border: none;
    }
  }

  > section {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    overflow-y: auto;
  }
`;

export const ContainerCollapsibleActivityTracker = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 380px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ContentCollapsibleActivityTracker = styled.div`
  width: 100%;
  .collapsible-header {
    background-color: #8e44ad;
    padding-bottom: 5px;
    color: white;
    font-weight: 700;
    font-size: 1rem;
    align-items: center;
    gap: 0.2rem;
    border-radius: 5px;
  }
`;
